/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CommentPencilRegular from './comment-pencil-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CommentPencilRegular {...validProps} />;
}
SvgComponent.iconName = 'commentPencilRegular';

export const CommentPencilRegularIcon = svgIconWrapper(SvgComponent);
